var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnhanceProfileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.852,
    height: 23.764,
    viewBox: "0 0 21.852 23.764",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4849",
    "data-name": "Rectangle 4849",
    width: 18.382,
    height: 22,
    fill: "#014fe0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13188",
    "data-name": "Group 13188",
    transform: "translate(-175 -415.236)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13161",
    "data-name": "Group 13161",
    transform: "translate(178.471 417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12142",
    "data-name": "Group 12142",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45194",
    "data-name": "Path 45194",
    d: "M14.96,208.642H3.4c-3.592-.5-3.7-3.558-3.166-6.5.439-2.4,1.745-4.93,4.56-4.891.57.008,1.479.8,2.014,1.083a4.987,4.987,0,0,0,4.854-.059c.524-.288,1.352-1.024,1.94-1.024,3.9,0,4.977,4.928,4.748,8.013a3.631,3.631,0,0,1-3.393,3.373",
    transform: "translate(0 -186.642)",
    fill: "#014fe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45195",
    "data-name": "Path 45195",
    d: "M80.189,5.3a5.3,5.3,0,1,1-5.3-5.3,5.3,5.3,0,0,1,5.3,5.3",
    transform: "translate(-65.842 -0.001)",
    fill: "#014fe0"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_45449",
    "data-name": "Path 45449",
    d: "M3.4,70.325c-.052-.05-.279-.778-.335-.917a3.527,3.527,0,0,0-2-2.072c-.343-.143-.719-.228-1.05-.4A.1.1,0,0,1,.05,66.8a4.679,4.679,0,0,0,2.509-1.507,7.75,7.75,0,0,0,.85-1.86c.094-.05.129-.007.169.076.137.281.218.652.34.949a3.506,3.506,0,0,0,2.1,2.021,8.807,8.807,0,0,1,.9.339c.065.087,0,.138-.076.176-.295.145-.709.23-1.024.365a3.537,3.537,0,0,0-1.891,1.929c-.123.3-.212.716-.355.984-.038.072-.1.117-.172.05",
    transform: "translate(175 358.238)",
    fill: "#014fe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45450",
    "data-name": "Path 45450",
    d: "M177.706,1.811a2.11,2.11,0,0,0-1.428.99,4.62,4.62,0,0,1-.314.727,8,8,0,0,1-.322-.744,1.853,1.853,0,0,0-.74-.723c-.19-.1-.464-.143-.63-.238-.083-.048-.083-.089,0-.131a3.519,3.519,0,0,0,.97-.469c.442-.378.43-.694.655-1.156.042-.087.083-.087.131,0,.1.171.148.463.255.663a1.821,1.821,0,0,0,.691.7c.248.139.531.176.755.33Z",
    transform: "translate(17.545 415.236)",
    fill: "#014fe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45451",
    "data-name": "Path 45451",
    d: "M176.686,231.634l.018.04c-.159.109-.36.136-.535.234a1.289,1.289,0,0,0-.489.495c-.076.142-.111.349-.18.47-.034.059-.063.059-.093,0-.159-.327-.151-.551-.464-.819a2.492,2.492,0,0,0-.687-.332c-.061-.03-.062-.059,0-.093.112-.065.314-.1.446-.169a1.312,1.312,0,0,0,.524-.512,5.669,5.669,0,0,1,.228-.527,3.272,3.272,0,0,1,.223.515,1.494,1.494,0,0,0,1.012.7",
    transform: "translate(4.546 188.735)",
    fill: "#014fe0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnhanceProfileIcon);
export default __webpack_public_path__ + "static/media/enhance-profile-icon.78054fa7f40360d409f72e75c32ae373.svg";
export { ForwardRef as ReactComponent };